/**
 * Vérifie si le clic est en dehors de l'élément.
 */
export function isClickedOutside(event, element) {
  if (event.target instanceof HTMLDialogElement || !(event.target instanceof Element)) {
    return !isPointWithinElement(event.clientX, event.clientY, element);
  }
  return !element.contains(event.target);
}

export const mediaQueryLarge = matchMedia('(width > 750px)');

export function isMobileBreakpoint() {
  return !mediaQueryLarge.matches;
}

export function isDesktopBreakpoint() {
  return mediaQueryLarge.matches;
}

/**
 * AKG - Formate le prix en euros sans décimales
 * Ex: 199900 -> "€ 1 990"
 */
export function formatMoney(moneyValue) {
  var euros = Math.round(moneyValue / 100);
  return '\u20ac\u00a0' + euros.toLocaleString('fr-FR');
}

export function formatCents(moneyValue, thousandsSeparator, decimalSeparator, precision) {
  const roundedNumber = (moneyValue / 100).toFixed(precision);
  let [a, b] = roundedNumber.split('.');
  if (!a) a = '0';
  if (!b) b = '';
  a = a.replace(/\d(?=(\d\d\d)+(?!\d))/g, (digit) => digit + thousandsSeparator);
  if (precision <= 0) return a;
  b = b.padEnd(precision, '0');
  if (Theme.trailingZeros == false && /^0+$/.test(b)) return a;
  return a + decimalSeparator + b;
}

export function isElementInViewport(element) {
  var top = element.offsetTop;
  var height = element.offsetHeight;
  while (element.offsetParent) {
    element = element.offsetParent;
    top += element.offsetTop;
  }
  return top < window.pageYOffset + window.innerHeight && top + height > window.pageYOffset;
}
